import { MenuItem} from '@mui/material';
import {SMCStyleMenuItem, SMCStyleMenuTitle} from '../../../assets/styles/styles';

function SMCMenuItem({
    title=false,
    children,
    style,
    ...rest
}) {

    let menuitemStyle = {};
    if (style)
        menuitemStyle = style;
    else
        menuitemStyle = title ? SMCStyleMenuTitle : SMCStyleMenuItem;

    return (
        <MenuItem 
            sx={menuitemStyle} 
            {...rest}
        >
            {children}
        </MenuItem>
    );
};



export default SMCMenuItem;